const CHECKOUT_STATUS_MESSAGES = {
  "checkout:success": {
    type: "success",
    message: "Checkout complete. Your subscription will update once Stripe confirms it.",
  },
  "checkout:cancelled": {
    type: "error",
    message: "Checkout cancelled. No subscription changes were made.",
  },
  "purchase:success": {
    type: "success",
    message: "Purchase complete. Your request will appear after Stripe confirms it.",
  },
  "purchase:cancelled": {
    type: "error",
    message: "Purchase cancelled. No charge was made.",
  },
};

export function getCheckoutStatusToast(searchParams) {
  const params =
    typeof searchParams === "string"
      ? new URLSearchParams(searchParams)
      : searchParams;

  const checkoutStatus = params?.get?.("checkout");
  if (checkoutStatus) {
    return CHECKOUT_STATUS_MESSAGES[`checkout:${checkoutStatus}`] || null;
  }

  const purchaseStatus = params?.get?.("purchase");
  if (purchaseStatus) {
    return CHECKOUT_STATUS_MESSAGES[`purchase:${purchaseStatus}`] || null;
  }

  return null;
}

export function clearCheckoutStatusParams(searchParams) {
  const params = new URLSearchParams(searchParams);
  params.delete("checkout");
  params.delete("purchase");
  return params;
}
